<!--AFP-->
<script setup>
import { computed, reactive,ref } from "vue";
import { useCrfStore } from "@/stores/crf";
import check from "./check.vue";
import upload from "@/components/upload1.vue"
import {useCommonStore} from "@/stores/common.js"
const commonStore = useCommonStore()
//不是筛选期
let notScreen = ref(false)
notScreen.value = commonStore.funNotScreen
//是不是v0
let isv0 = ref(false)
isv0.value = commonStore.isV0


// 定义组件属性
const props = defineProps({
  formModel: {},
  type: null
});

// 表单对象
const model = reactive(props.formModel);
const crfStore = useCrfStore();

// 节省代码长度，在模板中使用
const crfFields = computed(() => {
  return model.fields[`${props.type}`];
});

// 字段自动校验用于赋值 prop
const itemProp = function(prop) {
  return `fields['${props.type}']['${prop}']`;
};
</script>

<template>
  <template v-if="crfFields">
    <div style="display: flex;">
      <h2>AFP</h2>
      <upload :type="props.type" :data="model" name="afp"></upload>
      <check :period="props.type" text="AFP" :data="model" v-if="model.checkdata.ischeck == '是'"></check>

    </div>
    

    <el-form-item label="AFP是否适用肝筛选期数据"  v-if="crfFields && isv0" class="redStar">
      <el-radio-group v-if="notScreen" v-model="crfFields['AFP是否适用肝筛选期数据']">
        <el-radio label="是" prop="是"></el-radio>
        <el-radio label="否" prop="否"></el-radio>
      </el-radio-group>
    </el-form-item>
      <template v-if="crfFields['AFP是否适用肝筛选期数据'] == '否' || !isv0">
        <el-form-item :label="notScreen?'是否新增AFP':'AFP'"  v-if="crfFields && notScreen" class="redStar">
            <el-radio-group v-if="notScreen" v-model="crfFields['是否新增AFP']">
              <el-radio label="是" prop="是"></el-radio>
              <el-radio label="否" prop="否"></el-radio>
            </el-radio-group>

        </el-form-item>
        
        <template v-if="crfFields['是否新增AFP'] == '是' || !notScreen">
            <el-form-item label="AFP(ng/ml)" class="redStar" :prop="itemProp(`AFP`)" :rules="crfStore.textRules(`AFP`,true)">
              <el-input v-model="crfFields['AFP']" autocomplete="off">
                <template #append>ng/ml</template>
              </el-input>
            </el-form-item>
        </template>
      </template>
  </template>
</template>

<style scoped>
</style>